import React from 'react';

interface KpiCardProps {
    label: string;
    value: string | number;
    subValue?: string;
    icon: React.ReactNode;
    color: 'blue' | 'amber' | 'red' | 'emerald';
}

export default function KpiCard({ label, value, subValue, icon, color }: KpiCardProps) {
    const colors: Record<string, string> = {
        blue: 'text-blue-400 bg-blue-500/10 border-blue-500/20',
        amber: 'text-amber-400 bg-amber-500/10 border-amber-500/20',
        red: 'text-red-400 bg-red-500/10 border-red-500/20',
        emerald: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20',
    };

    const colorClasses = colors[color] || colors.blue;
    const borderClass = colorClasses.split(' ')[2];
    const bgClass = colorClasses.split(' ')[1];

    return (
        <div className={`p-4 rounded-xl border bg-[#0A0A0A] ${borderClass} flex items-center justify-between group hover:bg-[#111111] transition-colors`}>
            <div>
                <p className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">{label}</p>
                <div className="flex items-baseline gap-2 mt-1">
                    <p className="text-2xl font-bold text-white tracking-tight">{value}</p>
                    {subValue && <span className="text-[10px] text-gray-500">{subValue}</span>}
                </div>
            </div>
            <div className={`w-8 h-8 rounded-lg ${bgClass} flex items-center justify-center`}>
                {icon}
            </div>
        </div>
    );
}
